import { dataSourceIdMap } from "features/data-source/data-source-id-map";
import { nameToPathMap } from "features/data-source/data-source-registry";
import { toDataSourceParameters } from "features/data-source/useDataSource";
import { InvalidateCacheQuery } from "store/hooks/data-source-cache.types";
import {
    GetDataSourceOptions,
    GetDataSourceOptionsV1,
    GetDataSourceOptionsV2,
} from "store/services/data-source.service";
import { GetDataSourceDeprecatedOptions } from "store/services/deprecated/data-source.service";

export const getCacheArgs = (
    query: InvalidateCacheQuery,
    options: {
        shouldUseNewApproach: boolean;
        shouldUseJSBE: boolean;
    }
): GetDataSourceOptions | GetDataSourceDeprecatedOptions => {
    const { shouldUseNewApproach, shouldUseJSBE } = options;

    if (shouldUseNewApproach) {
        const path = nameToPathMap[query.name];
        const args: GetDataSourceOptionsV2 = { apiVersion: "v2", path, parameters: query.parameters };
        return args;
    } else if (shouldUseJSBE) {
        const args: GetDataSourceOptionsV1 = {
            apiVersion: "v1",
            id: dataSourceIdMap[query.name],
            parameters: toDataSourceParameters(query.parameters),
        };
        return args;
    } else {
        const args: GetDataSourceDeprecatedOptions = {
            id: dataSourceIdMap[query.name],
            parameters: toDataSourceParameters(query.parameters),
        };
        return args;
    }
};
